/**
 * Product page — switch main image via thumbnails and prev/next controls.
 */
(function () {
  function initGallery(root) {
    var main = root.querySelector("[data-lb-gallery-main]");
    var thumbs = root.querySelectorAll("[data-lb-gallery-thumb]");
    var counter = root.querySelector("[data-lb-gallery-counter]");
    var prevBtn = root.querySelector("[data-lb-gallery-prev]");
    var nextBtn = root.querySelector("[data-lb-gallery-next]");

    if (!main || thumbs.length < 2) return;

    var index = 0;

    function setIndex(nextIndex) {
      index = (nextIndex + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      var src = thumb.getAttribute("data-src");
      var srcset = thumb.getAttribute("data-srcset");
      if (!src) return;

      main.src = src;
      if (srcset) {
        main.srcset = srcset;
      } else {
        main.removeAttribute("srcset");
      }

      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });

      if (counter) {
        counter.textContent = index + 1 + " / " + thumbs.length;
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        setIndex(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        setIndex(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        setIndex(index + 1);
      });
    }

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        setIndex(index - 1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        setIndex(index + 1);
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-lb-product-gallery]").forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
